mutation ClearSentenceColors($barMitzvah: String!, $sentence: ID!, $overlay: ID) {
  clearSentenceColors(barMitzvah: $barMitzvah, sentence: $sentence, overlay: $overlay) {
    ok
    errors
  }
}
